import Vue from 'vue'

export default params => {
  return Vue.prototype.$axios({

  })
}
